import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MarcViewerService {
  public editionEntries: any = {
    'general': ['format', 'title', 'fullTitle', 'abbrTitle', 'formerTitle', 'uniformTitle',
      'alternateTitle', 'addedTitle', 'edition', 'author', 'vendor', 'publisherInfo', '' +
      'physicalDescription', 'electronicNote', 'frequency'],
    'languages': ['itemLanguage', 'workLanguage', 'langIncludesText', 'langSummary',
      'langSungSpoken', 'langLibrettos', 'langTableOfContents',
      'langAccMaterials', 'langOrigTranslatedFrom', 'langIntertitles', 'langSubtitles',
      'langInterTranslation', 'langOrigAccMaterials',
      'langOrigLibrettos', 'langCaptions', 'langAccessibleAudio', 'langAccessibleVisual', 'langAccTranscripts'
    ],
    'accessibility': ['accessibilityInfo'],
    'series': ['seriesTitle'],
    'swissCollections': ['swissCollections'],
    'subjects': ['subjPersonalName', 'subjCorporateName', 'subjMeetingName', 'subjNamedEvent',
      'subjChronologicalTerm', 'subjTopicalTerm', 'subjUncontrolledTerm', 'subjFacetedTopicTerm', 'subjGenre',
      'subjOccupation', 'subjFunction', 'subjCurriculumObj', 'subjPlaceName', 'subjEntityType', 'subjLocal'],
    'noteGeneral': ['noteGeneral', 'noteWith', 'noteDissertation', 'noteBibliography',
      'noteTableOfContents', 'noteRestrictions', 'noteScale', 'noteCredits', 'noteCitation', 'noteParticipant',
      'noteReport', 'noteDataQuality', 'noteNumbering', 'noteComputerFileType', 'noteEvent', 'noteSummary',
      'noteAudience', 'noteGeographic', 'notePrefCitation', 'noteSupplement', 'noteStudyProgram', 'noteAddlForm',
      'noteAccessibility', 'noteReproduction', 'noteOriginalVersion', 'noteLocationOriginals', 'noteFunding',
      'noteSystemDetails', 'noteTermsOfUse', 'noteSourceOfAcq', 'noteCopyrightStatus', 'noteLocationOtherMaterials',
      'noteBiographical', 'noteLanguage', 'noteFormerTitle', 'noteIssuingBody', 'noteEntityInfo',
      'noteCumulativeIndex', 'noteDocumentationInfo', 'noteOwnership', 'noteCopyVersion', 'noteBinding',
      'noteCaseFile', 'noteMethodology', 'noteLinkingEntry', 'notePublications', 'noteAction', 'noteAccumulation',
      'noteExhibitions', 'noteAwards', 'noteSourceOfDesc', 'noteLocal'
    ],
    'contributors': ['contributors'],
    'controlNumbers': ['isbn', 'issn', 'upc', 'publisherNumber', 'bibId'],
  }

  constructor() {
  }

  public marcJsonToView(marc: any): string {
    if (!marc) {
      return '';
    }

    let records_ol = '';
    records_ol += 'LEADER ' + marc.leader;

    // Iterate controlFields
    Object.entries(marc.controlFields).sort().forEach(([tag, values]: ['string', any]) => {
      values.forEach((value: any) => {
        // process each control field value
        records_ol += `\n${tag} ${value}`;
      });
    });

    // Iterate dataFields
    Object.entries(marc.dataFields).sort().forEach(([tag, fields]: ['string', any]) => {
      fields.forEach((field: any) => {
        // process each data field
        records_ol += `\n${tag} ${field.ind1}${field.ind2} `;
        field.subfields.forEach((subfield: any) => {
          // process each subfield
          records_ol += `\$${subfield.code} ${subfield.value} `;
        });
      });
    });

    return records_ol;
  }

  public groupMarcFields(editions: any, space: string) {
    return editions.filter((entry: any) => this.editionEntries[space].includes(entry.key));
  }
}
